import { FormattedMessage } from "react-intl";

export const POPULATION_DATE_CONSTANT = {
  NOW: "1",
  ANOTHER_DATE: "2",
};
export const POPULATION_DATE_OPTIONS = [
  { name: <FormattedMessage id="now" />, id: POPULATION_DATE_CONSTANT.NOW },
  {
    name: <FormattedMessage id="another-date" />,
    id: POPULATION_DATE_CONSTANT.ANOTHER_DATE,
  },
];
